import { render, staticRenderFns } from "./Resetpassword.vue?vue&type=template&id=7f9d0016"
import script from "./Resetpassword.vue?vue&type=script&lang=js"
export * from "./Resetpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports